import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { Spinner } from "@telegram-apps/telegram-ui";

import { canAccessRequest, getDefaultPath } from "./access";
import { useAppData } from "./AppData";
import { BottomNav } from "./components/BottomNav";
import { WebChrome } from "./components/WebChrome";
import { useTelegramApp } from "./hooks/useTelegramApp";
import { CategoryTab } from "./pages/CategoryTab";
import { DataSettingsPage } from "./pages/DataSettingsPage";
import { JobStatusPage } from "./pages/JobStatusPage";
import { OperationForm } from "./pages/OperationForm";
import { RequestPage } from "./pages/RequestPage";
import { SettingsPage } from "./pages/SettingsPage";
import { UserDetailPage } from "./pages/UserDetailPage";
import { UsersListPage } from "./pages/UsersListPage";

/** Раздел с нижним меню: основные табы и их подстраницы. */
function TabsLayout() {
  return (
    <>
      <Outlet />
      <BottomNav />
    </>
  );
}

/** Корень «/»: заявка при доступе, иначе первый доступный раздел. */
function HomeRoute() {
  const { me, operations, loading } = useAppData();
  if (loading) {
    return (
      <div style={{ padding: 32, textAlign: "center" }}>
        <Spinner size="m" />
      </div>
    );
  }
  if (canAccessRequest(me)) return <RequestPage />;
  return <Navigate to={getDefaultPath(me, operations)} replace />;
}

/** Неизвестный URL → первый доступный раздел (не на закрытую «Заявку»). */
function FallbackRedirect() {
  const { me, operations, loading } = useAppData();
  if (loading) {
    return (
      <div style={{ padding: 32, textAlign: "center" }}>
        <Spinner size="m" />
      </div>
    );
  }
  return <Navigate to={getDefaultPath(me, operations)} replace />;
}

export function App() {
  useTelegramApp();
  return (
    <>
      <WebChrome />
      <Routes>
      <Route element={<TabsLayout />}>
        <Route path="/" element={<HomeRoute />} />
        <Route path="/calc" element={<CategoryTab category="calc" header="Подсчёт" />} />
        <Route path="/views" element={<CategoryTab category="views" header="Просмотры" />} />
        <Route path="/report" element={<CategoryTab category="report" header="Отчёт" />} />
        <Route path="/settings" element={<SettingsPage />} />
      </Route>

      {/* Drill-down страницы — без нижнего меню, со своей кнопкой «Назад». */}
      <Route path="/settings/users" element={<UsersListPage />} />
      <Route path="/settings/users/:tgid" element={<UserDetailPage />} />
      <Route path="/settings/data" element={<DataSettingsPage />} />
      <Route path="/settings/contracts" element={<DataSettingsPage contractsOnly={true} />} />
      <Route path="/op/:opId" element={<OperationForm />} />
      <Route path="/job/:jobId" element={<JobStatusPage />} />
      <Route path="*" element={<FallbackRedirect />} />
      </Routes>
    </>
  );
}
